export default "__VITE_ASSET__49c85ac3__"